export default __webpack_public_path__ + "static/media/bannerC4FTour.5459f16c.png";